import Icon from '@components/Icon'
import featureToggles from 'shared/featureToggles'

import styles from './styles.module.scss'

const Legend = () => (
    <div className="d-flex">
        <div className={styles.legend}>
            <Icon type="park" className="mr-1" size="xxs" />
            <T>map.resultsList.legend.indigo</T>
        </div>
        {featureToggles.showOpngoResults && (
            <div className={styles.legend}>
                <Icon type="pin-opngo" className="mr-1" size="xxs" />
                <T>map.resultsList.legend.opngo</T>
            </div>
        )}
    </div>
)

export default Legend
